module.exports = __webpack_public_path__ + "static/media/empty2.61fc4494.png";